<template>
    <div v-if="loaded">
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-card>
                  <div slot="header">
                    <h4 class="ml-2">
                      Detail Pasien
                    </h4>
                  </div>
                    <vs-row class="mt-4 ml-4" style="font-size:14px">
                        <vs-col class="w-1/2 lg:w-1/6">
                            <label class="vs-radio--label">Nama Pasien / No MR</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/3">
                            <label class="vs-radio--label">: <b>{{detailData.patient.name}} / {{detailData.patient.patientNumber}}</b></label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/6">
                            <label class="vs-radio--label">Tanggal Visit / No Lab</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/3">
                            <label class="vs-radio--label">: <b>{{detailData.visitDate | formatDate}} / {{detailData.visitNumber}}</b></label>
                        </vs-col>
                      </vs-row>
                      <vs-row class="mt-2 ml-4 mb-4" style="font-size:14px">
                        <vs-col class="w-1/2 lg:w-1/6">
                            <label class="vs-radio--label">Tgl Lahir / Jenis Kelamin</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/3">
                            <label class="vs-radio--label">: <b>{{detailData.patient.dob | formatDate}} ({{detailData.patient.dob | calcAge1}}) / {{detailData.patient.gender.name}}</b></label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/6">
                            <label class="vs-radio--label">Status</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/3">
                            <label class="vs-radio--label">: <b>{{detailData.testStatusName}}</b></label>
                        </vs-col>
                    </vs-row>
                </vs-card>
            </div>
        </div>

        <vs-card style="min-height: 400px">
            <div slot="header">
              <div class="vx-row mb-2">
                  <div class="vx-col w-1/8 text-left">
                    <vs-button color="danger" type="filled" @click="back">Kembali</vs-button>
                  </div>
                  <div class="vx-col w-3/4 text-left">
                    <vs-input class="w-full" placeholder="Tuliskan Catatan Disini" v-model="notes"/>
                  </div>
                  <div class="vx-col w-1/8 text-left">
                    <vs-button color="success" type="filled" class="mr-4" @click="onConfirm">Simpan</vs-button>
                  </div>
              </div>
              <div class="vx-row">
                <div v-for="(data, idx) in detailData.visitNote" v-if="data.note!==''" class="w-full mr-8">
                  <vs-alert color="rgb(41, 147, 138)" title="Catatan Inputer" active="true" style="margin: 0 15px 5px 15px;" v-if="data.noteType==='ENTRY'">
                    <div class="flex">
                      <vx-tooltip :text="data.user.name" position="bottom">
                          <vs-avatar :src="'http://media.rinjani.healtri.com'+data.user.image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                      </vx-tooltip>
                      <label class="ml-4">{{data.note}}</label>
                    </div>
                  </vs-alert>
                  <vs-alert color="primary" title="Catatan Verifier" active="true" style="margin: 0 15px 5px 15px;" v-if="data.noteType==='VERIFY'">
                    <div class="flex">
                      <vx-tooltip :text="data.user.name" position="bottom">
                          <vs-avatar :src="'http://media.rinjani.healtri.com'+data.user.image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                      </vx-tooltip>
                      <label class="ml-4">{{data.note}}</label>
                    </div>
                  </vs-alert>
                  <vs-alert color="#842993" title="Catatan Validator" active="true" style="margin: 0 15px 5px 15px;" v-if="data.noteType==='VALIDATE'">
                    <div class="flex">
                      <vx-tooltip :text="data.user.name" position="bottom">
                          <vs-avatar :src="'http://media.rinjani.healtri.com'+data.user.image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                      </vx-tooltip>
                      <label class="ml-4">{{data.note}}</label>
                    </div>
                  </vs-alert>
                </div>
              </div>
            </div>
              <div class="vx-row">
                  <div class="vx-col w-full mt-2 mb-2 flex">
                      <vs-tabs>
                          <vs-tab :key="idy" v-for="(tab, idy) in detailData.groupTest" :label="tab.name">
                              <div class="tab-text" style="margin-bottom: 80px;">
                                  <vs-row class="mb-4 mt-4" style="border-bottom: 1px solid #d0d0d0">
                                      <vs-col class="w-1/2 lg:w-4/12">
                                          <label class="vs-radio--label">Pemeriksaan</label>
                                      </vs-col>
                                      <vs-col class="w-1/2 lg:w-4/12 text-center">
                                          <label class="vs-radio--label">Hasil</label>
                                      </vs-col>
                                      <vs-col class="w-1/2 lg:w-2/12 text-center">
                                          <label class="vs-radio--label">Unit</label>
                                      </vs-col>
                                      <vs-col class="w-1/2 lg:w-2/12 text-center">
                                          <label class="vs-radio--label">Nilai Normal</label>
                                      </vs-col>
                                  </vs-row>

                                  <worklist-entry-lists v-for="(tabTest,idx) in tab.test" :key="idx" :data="tabTest" v-model="tabTest.result"/>

                                  <template v-if="tab.chidlGroup !== null" v-for="child in tab.chidlGroup">
                                      <vs-row class="pb-5">
                                          <vs-col colspan="4"><label class="vs-radio--label"><b>{{child.name}}</b></label></vs-col>
                                      </vs-row>

                                      <worklist-entry-lists v-for="(tt,idx) in child.test" :key="'row_'+idx" :data="tt" :is-child="true" v-model="tt.result"/>
                                  </template>

                              </div>
                          </vs-tab>
                          <vs-tab label="Cycle Thresholds (CT)" v-if="$route.params.from==='pcr'">
                            <div class="tab-text" style="margin-bottom: 80px;">
                                <vs-row class="mb-4 mt-4" style="border-bottom: 1px solid #d0d0d0">
                                    <vs-col class="w-1/2 lg:w-4/12">
                                        <label class="vs-radio--label">Pemeriksaan</label>
                                    </vs-col>
                                    <vs-col class="w-1/4 lg:w-4/12 text-center">
                                        <label class="vs-radio--label">Hasil</label>
                                    </vs-col>
                                </vs-row>

                                <vs-row class="mb-4" v-for="(tt,idx) in detailData.genTarget" >
                                    <vs-col class="w-1/2 lg:w-4/12">
                                        <label class="vs-radio--label">{{tt.name}}</label>
                                    </vs-col>
                                    <vs-col class="w-1/4 lg:w-4/12 text-center flex">
                                        <div class="centerx default-input w-full">
                                          <vs-input :disabled="!tt.enable" placeholder="Result" v-model="tt.result" class="w-full"/>
                                        </div>
                                    </vs-col>
                                  </vs-row>
                            </div>
                          </vs-tab>
                      </vs-tabs>
                  </div>
              </div>
        </vs-card>
    </div>
</template>

<script>
    import visit from "@/api/visit";
    import WorklistEntryLists from "./WorklistEntryLists";
    import CurrencyInput from "@/components/currency-input";

    export default {
        components: {
          CurrencyInput
        },
        data() {
            return {
                loaded: false,
                detailData: null,
                catatan: '',
                id: null,
                notes: '',
                inputerNotes: 'test catatan inputer',
                verifierNotes: 'test catatan verifier',
                validatorNotes: 'test catatan validator'
            }
        },
        components: {
            WorklistEntryLists
        },
        mounted() {
    		  this.firstLoad();
        },
        methods: {
            back() {
              if (this.$route.params.from==='clinic') {
                this.$router.push({name:'worklist-klinik'});
              }

              if (this.$route.params.from==='pcr') {
                this.$router.push({name:'worklist-pcr'});
              }
            },
            async firstLoad() {
                let idx = this.$route.params.id;
                if (idx) {
                    const xmodel = await visit.getDetailV2(idx);
                    this.detailData = xmodel.data.data[0];
                    this.loaded = true;
                    this.id = idx;
                }
            },
            getMeasureRange(measureRangeVal) {
                for(let a = 0; a < measureRangeVal.length; a++) {
                    if(measureRangeVal[a].genderId === this.detailData.patient.genderId) {
                        if(measureRangeVal[a].rangeUpper === null) {
                            return measureRangeVal[a].rangeLower;
                        }

                        return measureRangeVal[a].rangeLower + ' - ' + measureRangeVal[a].rangeUpper;
                    }
                }
            },
            onConfirm() {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Konfirmasi`,
                    text: 'Simpan Data Entry ?',
                    acceptText: 'Ya',
                    cancelText: 'Tidak',
                    accept: this.saveData
                });
            },
            saveData() {
                this.loading = true;
                let config = {
                    headers: {
                        "content-type": "application/json"
                    }
                };

                let model = { id: this.id };
                let testName = [];
                for(let a = 0; a < this.detailData.groupTest.length; a++) {
                    let gr = this.detailData.groupTest[a];
                    for(let b = 0; b < gr.test.length; b++) {
                        let ts = gr.test[b];
                        let res = '';
                        if(ts.result!=null) {
                          res = ts.result.toString();
                          if (res != '') {
                              testName.push(ts);
                          }
                        }
                    }

                    if (gr.chidlGroup != null) {
                        for(let b = 0; b < gr.chidlGroup.length; b++) {
                            let ggr = gr.chidlGroup[b];
                            for(let c = 0; c < ggr.test.length; c++) {
                                let ts = ggr.test[c];
                                let res = '';
                                if(ts.result!=null) {
                                  res = ts.result.toString();
                                  if (res != '') {
                                      testName.push(ts);
                                  }
                                }
                            }
                        }
                    }
                }

                let arr = [];
                for (let y = 0; y < testName.length; y++) {
                    let obj = testName[y];
                    if (typeof obj.result === 'object' && obj.result != null) {
                        obj.result = obj.result.name;
                    }
                    arr.push(obj);
                }

                model.result = arr;
                model.genTarget = this.detailData.genTarget;

                const user = JSON.parse(localStorage.getItem("userInfo"));
                model.note = { "user" : { id:  user.uid}, "note" : this.notes };
                this.$vs.loading({
                  type:'sound',
                });
                visit.entry(model, config)
                    .then(res => {
                        if (res.data.status) {
                            this.$vs.notify({
                                title: "Konfirmasi Simpan Data",
                                time: 3000,
                                text: 'Data Entry Berhasil di Simpan',
                                color: "success",
                                position: "top-right"
                            });

                            this.$vs.loading.close();
                            this.back();
                        } else {
                            this.$vs.notify({
                                title: "Terjadi Kesalahan",
                                time: 3000,
                                text: res.data.message,
                                color: "danger",
                                position: "top-right"
                            });
                            this.$vs.loading.close();
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            this.$vs.notify({
                                title: "An Error Occured",
                                time: 3000,
                                text: error.response.data.message,
                                color: "danger",
                                position: "top-right"
                            });
                        }
                        this.$vs.loading.close();
                    })
                    .finally(() => (this.$vs.loading.close()));
            }
        }
    }
</script>
